<template>
  <layout></layout>
</template>

<script>
/* eslint-disable */
import { mapGetters, mapActions } from "vuex";
import layout from './components/layouts/Layout.vue';

export default {
  name: "VueCRUD",
  components: {
    layout,
  },

  computed: {
    ...mapGetters(["userObject", "user"]),
  },

  mounted() {
    // Tab sync logic: Listen for changes in localStorage from other tabs
    window.addEventListener("storage", this.handleStorageChange);
    // Focus sync logic: Check state when focusing back on an old tab
    window.addEventListener("visibilitychange", this.handleVisibilityChange);
  },

  beforeUnmount() {
    // Cleanup listeners to prevent memory leaks
    window.removeEventListener("storage", this.handleStorageChange);
    window.removeEventListener("visibilitychange", this.handleVisibilityChange);
  },

  methods: {
    ...mapActions(["resetSate"]),

    /**
     * Triggered when localStorage is modified in another tab
     */
    handleStorageChange(event) {
      // Monitor 'user' key change and sync ONLY if the user is on this tab
      if (event.key === 'user') {
        this.compareAndSync();
      }
    },

    /**
     * Triggered when user switches back to this tab
     */
    handleVisibilityChange() {
      if (document.visibilityState === 'visible') {
        this.compareAndSync();
      }
    },

    /**
     * Validates if the current Vuex state matches the LocalStorage state.
     * Logic: Reload ONLY when tab is visible and ONLY if _token changed.
     */
    compareAndSync() {
      // REQUISITE 1: Reload only when the tab becomes active/visible
      if (document.visibilityState !== 'visible') {
        return;
      }

      // EXEMPTION: Do not sync/reload if on login or sso login pages
      // This prevents interrupting user interaction (like confirmation popups)
      const authPages = ['login', 'ssoLogin'];
      if (authPages.includes(this.$route.name)) {
        return;
      }

      const storageUserRaw = localStorage.getItem('user');
      const userFromStorage = storageUserRaw ? JSON.parse(storageUserRaw) : null;
      
      // Get current token from Vuex (checking both user and userObject for safety)
      const currentUser = this.userObject?.user ? this.userObject : this.user;
      const currentToken = currentUser?._token;

      // 1. If logged out in another tab
      if (!userFromStorage && currentToken) {
        console.log("Session ended in another tab. Redirecting to login...");
        this.resetSate();
        if (this.$route.name !== 'login') {
          this.$router.push({ name: 'login' });
        }
        return;
      }

      // 2. REQUISITE 2: Reload ONLY if _token changed
      if (userFromStorage && currentToken) {
        const storageToken = userFromStorage?._token;

        if (storageToken !== currentToken) {
          console.warn("Auth token updated in another tab. Refreshing tab...");
          if (this.$route.name == 'dashboard') {
            window.location.reload(true) // force reload
          } else {
            window.location.href = '/dashboard'
          }
        }
      }
      
      // 3. New login detected (Tab was guest, now storage has user)
      if (userFromStorage && !currentToken) {
          if (this.$route.name == 'dashboard') {
            window.location.reload(true) // force reload
          } else {
            window.location.href = '/dashboard'
          }
      }
    }
  }
};
</script>